import { MagicLinkVerify } from '../components/MagicLinkVerify';

export function PortalVerifyPage() {
  return <MagicLinkVerify />;
}
